/*
Defines jspsych objects for instruction screens.
*/
import jsPsychAudioMultiResponse from "@jspsych-contrib/plugin-audio-multi-response";
import { mediaAssets } from "../../.."; //media files
import i18next from "i18next";
import "../../../i18n/i18n";
import store from "store2"; //storing session data
import { dashToCamelCase } from "../../shared/helpers";

export const intro = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio[
      dashToCamelCase(
        "introduction-" +
          store.session.get("config").taskName +
          "-" +
          store.session.get("config").labId,
      )
    ];
  },
  prompt: () => {
    let imageName = mediaAssets.images.paperPencilGreen;
    if (store.session.get("config").taskName === "fluency-arf") {
      imageName = mediaAssets.images.paperPencilRed;
    }

    return `
        <div class="tiger-gif-container">
          <div class="speechbubble">
            <h1 class="header">${i18next.t(
              "intro." +
                store.session.get("config").taskName +
                "." +
                store.session.get("config").labId,
            )} </h1>
            <p class="text"> ${i18next.t(
              "intro." + store.session.get("config").taskName + ".text1",
            )} </p>
            <div class="text-image">
              <img class="clipart" src=${imageName} alt="paper and pencil"/>
              <p class="text"> ${i18next.t(
                "intro." + store.session.get("config").taskName + ".text2",
              )} </p>
            </div>
            
          </div>
          <img class="roam-tiger" src=${
            mediaAssets.images[store.session.get("displayImage")]
          } alt="tiger"/>
        </div>
        <div class="key-button"> ${i18next.t("navigation.continueButtonText", {
          input: `${i18next.t("terms.anyKey")}`,
          action: `${i18next.t("terms.continue")}`,
        })} </div>
      `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
  on_start: () => {
    document.body.style.cursor = "none";
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  },
};

export const postPracticeReminder = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio.postPractice1Fluency;
  },
  prompt: () => {
    return `
      <div class="tiger-gif-container">
        <div class="speechbubble">
        <h3 class="header">${i18next.t("postPractice.text1")} </h3>
          <p class="text"> ${i18next.t("postPractice.text2")} </p>
          <p class="text"> ${i18next.t("postPractice.text3")} </p>
          <p class="text"> ${i18next.t("postPractice.text4")} </p>
        </div>
        <img class="roam-tiger" src=${
          mediaAssets.images[store.session.get("displayImage")]
        } alt="tiger"/>
      </div>
      <div class="key-button"> ${i18next.t("navigation.continueButtonText", {
        input: `${i18next.t("terms.anyKey")}`,
        action: `${i18next.t("terms.continue")}`,
      })} </div>
    `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
};

export const postPracticeIntro = {
  type: jsPsychAudioMultiResponse,
  stimulus: () => {
    return mediaAssets.audio[
      dashToCamelCase("post-practice2-" + store.session.get("config").taskName)
    ];
  },
  prompt: () => {
    let imageFile = mediaAssets.images[store.session.get("displayImage")];
    let instructionText =
      "postPractice." + store.session.get("config").taskName;
    if (store.session.get("config").taskName === "fluency-calf") {
      imageFile = mediaAssets.images.paperAndPencil;
      instructionText =
        "postPractice." +
        store.session.get("config").taskName +
        "-" +
        store.session.get("config").labId;
      if (store.session.get("config").labId === "numberLab") {
        imageFile = mediaAssets.images.paperAndPencilCalculatorVertical;
      }
    }
    return `
    <div class="tiger-gif-container">
      <div class="speechbubble">
        <h3 class="header">${i18next.t("postPractice.text5")} </h3>
        <p class="text"> ${i18next.t(instructionText)} </p>
        <p class="text"> ${i18next.t("postPractice.text6", {
          time: `${store.session.get("totalTimePB") / 60000}`,
        })} </p>
        <p class="text"> ${i18next.t("postPractice.text7")} </p>
        <p class="text"> ${i18next.t("postPractice.text8")} </p>
        
      </div>
      <img class="roam-tiger" src=${imageFile} alt="tiger"/>
    </div>
    
    <div class="key-button"> ${i18next.t("postPractice.text9")} </div>
  `;
  },
  keyboard_choices: () => "ALL_KEYS",
  button_choices: () => [],
};
